module.exports = __webpack_public_path__ + "img/lang-en.dcfbabc0.png";